export const BannerImgs = (bannerToShow) => {
    return imgArray[bannerToShow][Math.floor(Math.random() * imgArray[bannerToShow].length)];
}

const imgArray = {
    "argento": [
        // {
        //     ampLink: 'https://www.infocasas.com.uy/proyectos/fly-and-buy/amp?utm_source=web&utm_medium=popup',
        //     desktop: 'https://cdn1.infocasas.com.uy/web/638517a081508_continents-popup-desktop.png',
        //     mobile: 'https://cdn1.infocasas.com.uy/web/6385179f98453_continents-popup-mobile.png'
        // },
    ],
    "chile": [
        {
            ampLink: 'https://www.infocasas.com.uy/proyectos/fly-and-buy/amp?utm_source=web&utm_medium=popup',
            desktop: 'https://cdn1.infocasas.com.uy/web/638517a081508_continents-popup-desktop.png',
            mobile: 'https://cdn1.infocasas.com.uy/web/6385179f98453_continents-popup-mobile.png'
        }
    ]
}
